export interface RRCustomMannequinModel {
  bodymodelstate: Blob | string;
  model: Blob | string;
}
